// extracted by mini-css-extract-plugin
export default {"search":"Search_search__s+Edj","spinner":"Search_spinner__++ggE"};